







































import {Component, Vue} from 'vue-property-decorator';
import DashboardIcon from '../assets/icon-dashboard.svg';
import AutomatedAIMarketingIcon from '../assets/icon-rocket.svg';
import FlashOffersIcon from '../assets/icon-megaphone.svg';
import ArrowRightIcon from '../assets/arrow-right.svg';


@Component({
	components: {
		DashboardIcon: DashboardIcon,
		AutomatedAIMarketingIcon: AutomatedAIMarketingIcon,
		FlashOffersIcon: FlashOffersIcon,
		ArrowRightIcon: ArrowRightIcon,
	},
	computed: {}
})
export default class Home extends Vue {


}
